import {Component, Input, ViewEncapsulation, ChangeDetectionStrategy} from '@angular/core';
import {MultiTenantService} from '../../../services/multi-tenant.service';

@Component({
    selector: 'app-product-item-number',
    templateUrl: './product-item-number.component.html',
    styleUrls: ['./product-item-number.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
    changeDetection: ChangeDetectionStrategy.Eager
})
export class ProductItemNumberComponent {

  @Input() public supplierId: string;

  @Input() public itemNumber  = '';

  @Input() public className = '';

  @Input() hsCode: string | null = null;

  constructor(private multiTenant: MultiTenantService) { }

  get supplierLabel(): string {
    return this.multiTenant.productCodeLabel;
  }

  get showProductCode(): boolean {
    return this.multiTenant.showProductCodeLabel;
  }
}
